/* START: SWIPER JS START */

// const swiperwda = new Swiper(".swiper-slide-service", {
//   loop: true,
//   slidesPerView: 5,
//   slidesPerColumn: 5,
//   spaceBetween: 10,
//   autoplay: {
//     delay: 4500,
//     disableOnInteraction: false,
//   },
//   // freeMode: true,

//   // If we need pagination
//   // pagination: {
//   //   el: '.swiper-pagination',
//   // },

//   // Navigation arrows
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },

//   breakpoints: {
//     120: {
//       slidesPerView: 1,
//     },
//     320: {
//       slidesPerView: 2,
//       slidesPerColumn: 2,
//     },
//     640: {
//       slidesPerView: 2,
//     },
//     768: {
//       slidesPerView: 3,
//     },
//     1024: {
//       slidesPerView: 6,
//     },
//   },
// });

/* START: SWIPER ANNOUNCEMENT */

const swiperwd = new Swiper(".swiper-announcement", {
  // Optional parameters
  loop: true,
  slidesPerView: 1,
  slidesPerColumn: 1,
  autoplay: {
    delay: 4500,
    disableOnInteraction: false,
  },

  navigation: {
    nextEl: ".wwad",
    prevEl: ".cwda",
  },
});


const newswiper = new Swiper(".swiper-slide-custom-logo", {
  loop: true,
  slidesPerView: 1,
  slidesPerColumn: 1,
  spaceBetween: 10,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  // freeMode: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  // navigation: {
  //   nextEl: ".swiper-button-next",
  //   prevEl: ".swiper-button-prev",
  // },

  breakpoints: {
    120: {
      slidesPerView: 1,
    },
    320: {
      slidesPerView: 1,
      slidesPerColumn: 1,
    },
    640: {
      slidesPerView: 1,
      slidesPerColumn: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 5,
    },
  },
});


window.Swiper = Swiper